import React, { useEffect, ReactNode } from 'react';

interface DocumentTitleProps {
  title: string;
  children?: ReactNode;
}

/**
 * Sets the document title. Replacement for react-document-title
 * which uses deprecated componentWillMount lifecycle.
 */
const DocumentTitle: React.FC<DocumentTitleProps> = ({ title, children }) => {
  useEffect(() => {
    const previousTitle = document.title;
    document.title = title;

    return () => {
      document.title = previousTitle;
    };
  }, [title]);

  return <>{children}</>;
};

export default DocumentTitle;
